module.exports = __webpack_public_path__ + "img/logo.3664a8f6.png";